import { useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { FetchTagsParams, fetchTags } from 'api/tags';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useInfiniteScroll } from 'customHooks/useInfiniteScroll';
import { transformInfiniteQueryOptions } from 'helpers/reactQuery';
import { accountQueryKeys } from 'queries/account-query-keys';
import { Tag } from 'types/domain';
import {
    GivebutterInfiniteQueryParams,
    GivebutterUseSuspenseInfiniteQueryOptions,
} from 'types/react-query';

const DEFAULT_PAGE_LIMIT = 20;

const useInfiniteTags = (
    params: GivebutterInfiniteQueryParams<FetchTagsParams> = {},
    options: GivebutterUseSuspenseInfiniteQueryOptions<Tag> = {},
) => {
    const { per_page = DEFAULT_PAGE_LIMIT, ...rest } = params;
    const nextParams = { per_page, ...rest };
    const { accountId } = useCurrentAccount();
    const infiniteQueryData = useSuspenseInfiniteQuery({
        initialPageParam: 1,
        queryKey: accountQueryKeys.tagsWithFilters(accountId, nextParams),
        queryFn: ({ pageParam }) => fetchTags(accountId, { page: pageParam, ...nextParams }),
        ...transformInfiniteQueryOptions<Tag>(),
        ...options,
    });
    const ref = useInfiniteScroll(infiniteQueryData);

    return { ...infiniteQueryData, ref };
};

export { useInfiniteTags };
